import { userEntryRequest, specificEMSPacket } from "./emslistSlice";

export const UserEnter = (data) => ({
  type: "USER_ENTER",
  userID: data.id,
});

export const EmsPacket = (data) => ({
  type: "EMS_PACKET",
  emsPacket: data,
});

/* Used only by actions for sockets */
export const initialEMSList = (res) => ({
  type: "INITIAL_LIST",
  items: res,
});

/***************************************************************************************** */
/* Async Action items using - Sockets													   */
/***************************************************************************************** */
export const loadInitialDataSocket = (socket) => {
  return (dispatch) => {
    // dispatch(clearAllItems())
    socket.on("initialList", (res) => {
      console.dir(res);
      // dispatch(initialItems(res));
    });
  };
};

export const userEnterSocket = (socket, data) => {
  return (dispatch) => {
    socket.emit("UserEntry", data);
    dispatch(mqtServerID(socket));
  };
};
export const mqtServerID = (socket) => {
  return (dispatch) => {
    socket.on("UserID", (message) => {
      
      let userID = JSON.parse(message)["userID"];
      dispatch(userEntryRequest({ userID: userID }));
    
    });
  };
};
export const emsPacketSocket = (socket, data) => {
  return (dispatch) => {
    let postData = {
      emsID: data.emsID,
      userID: data.userID,
    };
    socket.emit("SpecificEMSData", postData);
    return dispatch(SpecificEMSData(socket, data.emsID));
  };
};

export const SpecificEMSData = (socket, emsID) => {
  return (dispatch) => {
    socket.on("selectedEMSData", (message) => {
      let { BatteryID } = JSON.parse(message);
      // dispatch(specificEMSPacket({ emsID, emsPacket: JSON.parse(message) }));
    });
  };
};

export const setEMSID = (socket, data) => {
  console.log(socket);
  return (dispatch) => {
    let postData = {
      emsID: data.emsID,
      userID: data.userID,
    };
    socket.emit("SpecificEMSData", postData);
    // return dispatch(SpecificEMSData(socket, data.emsID));
  };
};

export const sendCommand = (socket, data) => {
  return (dispatch) => {
    console.log("Data", data);
    socket.emit("Command", data);
  };
};

// ijzLMdMAIZU7IMytAAAB;
